import { createFileRoute } from '@tanstack/react-router';
import { ExpenseLedgerPage } from '@/components/employee/expense-ledger/expense-ledger-page';

export const Route = createFileRoute('/(app)/employee/expense-ledger/')({
  component: EmployeeExpenseLedgerRoute,
});

function EmployeeExpenseLedgerRoute() {
  return <ExpenseLedgerPage />;
}
